var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pjh_div"}})
}
var staticRenderFns = []

export { render, staticRenderFns }